module.exports = __webpack_public_path__ + "static/media/monospace.27b3c8da.svg";